import React from "react";
import { Row, Col } from "antd";
import { FilterFilled } from '@ant-design/icons';
import "./OrderQueue.css";
import OrderCard from "../OrderCard/OrderCard";

const PendingQueue = Col;
const RoutedQueue = Col;
const PackagedQueue = Col;

const OrderQueue = () => {
  return (
    <Row gutter={16} >
      <Col span={8}>
      <PendingQueue className="column-box" >
          <Row className="title-font" justify="space-between">
            Pending
            <FilterFilled style={{ fontSize: 16, color: '#999' }} />
          </Row>
          <OrderCard/>
      </PendingQueue>
      </Col>
      <Col span={8}>
        <RoutedQueue className="column-box">
          <Row className="title-font" justify="space-between">
            Routed
            <FilterFilled style={{ fontSize: 16, color: '#999' }} />
          </Row>
        </RoutedQueue>
      </Col>
      <Col span={8}>
        <PackagedQueue className="column-box">
          <Row className="title-font" justify="space-between">
            Packaged
            <FilterFilled style={{ fontSize: 16, color: '#999' }} />
          </Row>
        </PackagedQueue>
      </Col>
    </Row>
  );
};

export default OrderQueue;
